module.exports = __webpack_public_path__ + "static/00003.2a3d9ce8.jpg";